import { httpClient } from "../baseDataProvider";
import { ATS_API_URL, OLD_DOCUPLOAD_API } from "../../config";
import { sanitizeQueryParams } from "../helpers/sanitizeQueryParams";
const API_URL = ATS_API_URL;
const API_URL_DOC = `${API_URL}/applicant`;

// 1. getapplicationprofiledetails
export const handleGetApplicationProfileDetails = async (params) => {
  const requestId = Array.isArray(params?.id) ? params.id[0] : params?.id;
  const { json /*, headers, status */ } = await httpClient(
    API_URL + `/subscriber/getapplicationprofiledetails?id=${requestId || ""}`,
  );
  const profileId =
    requestId ||
    json?.data?.profiledetails?.[0]?.ID ||
    json?.data?.profiledetails?.[0]?.id ||
    1;
  return {
    data: { ...json?.data, id: profileId },
  };
};

// 2. getsubscribermanagerandleads
export const handleGetSubscriberManagerAndLeads = async (params) => {
  const SubscriberData = localStorage.getItem("RaStore.switchSubscriberName");
  const { data: authData } = JSON.parse(localStorage.getItem("auth") || "{}") || {}; // Added default for JSON.parse
  const SubscriberDataJson = SubscriberData ? JSON.parse(SubscriberData) : null;
  const subscriberId = SubscriberDataJson?.value || authData?.subscriberid;
  const { json /*, headers, status */ } = await httpClient(
    API_URL + `/subscriber/getsubscribermanagerandleads?subscriberid=${subscriberId}`
  );
  // const r = json;
  return {
    data: { ...json, id: 1 }, // Original used r
  };
};

// 3. viewadverseletter
export const handleViewAdverseLetter = async (params) => {
  const { json /*, headers, status */ } = await httpClient(
    API_URL + `/subscriber/viewadverseletter?ApplicantID=${params?.id}&ApplicationStatus=${params?.meta?.ApplicationStatus}`
  );
  // const r = json;
  return {
    data: { ...json, id: 1 }, // Original used r
  };
};

// 4. getEmployerValidationCheck
export const handleGetEmployerValidationCheck = async (params) => {
  const { json /*, headers, status */ } = await httpClient(
    API_URL + `/subscriber/getEmployerValidationCheck/${params?.id}`
  );
  // const r = json;
  return {
    data: { ...json?.data, id: 1 }, // Original used r?.data
  };
};

// 5. getBankValidationCheck
export const handleGetBankValidationCheck = async (params) => {
  const { json /*, headers, status */ } = await httpClient(
    API_URL + `/subscriber/getBankValidationCheck/${params?.id}`
  );
  // const r = json;
  return {
    data: { ...json?.data, id: 1 }, // Original used r?.data
  };
};

// 6. getIDValidationCheck
export const handleGetIDValidationCheck = async (params) => {
  const { json /*, headers, status */ } = await httpClient(
    API_URL + `/applicant/applicant/getIDValidationCheck/${params?.id}`
  );
  // const r = json;
  return {
    data: { ...json?.records, id: 1 }, // Original used r?.records
  };
};

// 7. getTermsCondition
export const handleGetTermsCondition = async (params) => {
  const { data: authData } = JSON.parse(localStorage.getItem("auth") || "{}") || {};
  const { json /*, headers, status */ } = await httpClient(
    API_URL + `/subscriber/gettandc?subscriberid=${authData?.subscriberid}`
  );
  // const r = json;
  return {
    data: { ...json?.[0], id: 1 }, // Original used r?.[0]
  };
};

// 8. getTermsConditionLandlord
export const handleGetTermsConditionLandlord = async (params) => {
  const { json /*, headers, status */ } = await httpClient(
    API_URL + `/subscriber/getlandlordtandc`
  );
  return {
    data: { Description: json?.data, id: 1 },
  };
};

// 9. getsectionavailable
export const handleGetSectionAvailable = async (params) => {
  const { json /*, headers, status */ } = await httpClient(
    API_URL + `/admin/getsectionavailable?applicantID=${params?.id}`
  );
  // const r = json;
  return {
    data: { ...json?.data }, // Original used r?.data, and id was not added here
  };
};

// 10. getTokkenDetails
export const handleGetTokkenDetails = async (params) => {
  const { json /*, headers, status */ } = await httpClient(
    API_URL + `/auth/gettokendetails?token=${params.id}`
  );
  // const r = json;
  return {
    data: { ...json?.data, id: params.id }, // Original used r?.data
  };
};

// 11. getApplicantDetails
export const handleGetApplicantDetails = async (params) => {
  const { json /*, headers, status */ } = await httpClient(
    API_URL_DOC + `/auth/GetApplicantDetails/${params.id}`
  );
  // const r = json;
  return {
    data: { ...json?.records, id: params.id }, // Original used r?.records
  };
};

// 12. mlclassdetails
export const handleMlClassDetails = async (params) => {
  const { json } = await httpClient(
    API_URL_DOC + `/ml/getTemplateById/${params.id}`,
    {
      method: "GET",
    }
  );
  // const r = json;
  return {
    data: {
      ...json?.records, // Original used r?.records. No id was added to data top-level here.
    },
  };
};

// 13. getSubscriberProfileSection_new
export const handleGetSubscriberProfileSectionNew = async (params) => {
  const { json /*, headers, status */ } = await httpClient(
    API_URL_DOC + `/document/getSubscriberProfileSection_new/${params.id}`
  );
  // const r = json;
  return {
    data: {
      id: params.id,
      status: json?.records, // Original used r?.records
    },
  };
};

// 14. proofOfIdsData
export const handleProofOfIdsData = async (params) => {
  const { json }: any = await httpClient(
    API_URL_DOC + `/applicant/getidentification/${params.id}`
  );
  const r = json;
  let otherNoDocReason: string | null = null;
  let noDocReason: string | null = null;
  if (r?.records.identification_data.file) {
    otherNoDocReason = null;
    noDocReason = null;
  } else if (!r?.records.identification_data.no_doc_reason) {
    otherNoDocReason = null;
    noDocReason = "I do not currently have access to document(s), but can provide later";
  } else if (
    r?.records.identification_data.no_doc_reason !=
    "I do not currently have access to document(s), but can provide later" &&
    r?.records.identification_data.no_doc_reason !=
    "I do not have proof of identification"
  ) {
    otherNoDocReason = r?.records.identification_data.no_doc_reason;
    noDocReason = "Other";
  } else {
    otherNoDocReason = null;
    noDocReason = r?.records.identification_data.no_doc_reason;
  }
  return {
    data: {
      id: params.id,
      ...r?.records,
      identification_data: {
        ...r?.records.identification_data,
      },
    },
  };
};

// 15. income
export const handleIncome = async (params) => {
  const { json /*, headers, status */ } = await httpClient(
    API_URL_DOC + `/income/getIncome/${params.id}`
  );
  const r = json; // Original uses 'r' for complex logic below

  const statedefaultValue = (employer_state) => {
    const findStatedefaultValue = r?.records?.States?.find(
      (item) => item?.StateShortCode === employer_state // Original had '=='
    );
    if (findStatedefaultValue) {
      return {
        label: findStatedefaultValue
          ? findStatedefaultValue?.StateShortCode +
          " - " +
          findStatedefaultValue?.StateName
          : null,
        value: findStatedefaultValue ? findStatedefaultValue?.ID : null,
      };
    } else {
      return null;
    }
  };

  const newRes1 = {
    ...r,
    records: {
      ...r?.records,
      employment_details: {
        ...r?.records?.employment_details,
        employer: r?.records?.employment_details?.employer?.map((item) => { // Added optional chaining
          return {
            ...item,
            files: item.files.map((file) => {
              return {
                ...file,
                Pay_date: file?.Pay_date?.split("T").shift(),
                End_date: file?.End_date?.split("T").shift(),
                Start_date: file?.Start_date?.split("T").shift(),
                Pay_frequency: {
                  value: file.Pay_frequency,
                  label: file.Pay_frequency,
                },
              };
            }),
            employer_status: item?.employer_status
              ? {
                value: item?.employer_status,
                label: item?.employer_status,
              }
              : null,
            pay_frequency: item?.pay_frequency
              ? { value: item?.pay_frequency, label: item?.pay_frequency }
              : null,
            employer_state: statedefaultValue(item?.employer_state),
            availableToUpload:
              item.files.length > 0
                ? "Yes"
                : item.no_doc_reason == null // Original had '=='
                  ? ""
                  : "No",
            fileCount: item.files.length,
          };
        }),
        employerCount: r?.records?.employment_details?.employer?.length, // Added optional chaining
      },
    },
  };
  return {
    data: {
      id: params.id,
      ...newRes1.records,
    },
  };
};

// 16. bankDoc
export const handleBankDoc = async (params) => {
  const { json /*, headers, status */ } = await httpClient(
    API_URL_DOC + `/income/getbank/${params.id}`
  );
  const r = json; // Original uses 'r'

  const newRes1 = {
    ...r,
    records: {
      ...r?.records,
      banking_details: {
        ...r?.records?.banking_details,
        banking: r?.records?.banking_details?.banking?.map((item) => { // Added optional chaining
          return {
            ...item,
            availableToUpload:
              item.files.length > 0
                ? "Yes"
                : item.no_doc_reason != null // Original had '!='
                  ? "No"
                  : "",
            no_doc_reason:
              item.files.length > 0
                ? null
                : item.no_doc_reason ||
                "I don't currently have access to document(s), but can provide later",
            fileCount: item.files.length,
          };
        }),
      },
    },
  };
  return {
    data: {
      id: params.id,
      ...newRes1.records,
    },
  };
};

// 17. otherIncomeDoc
export const handleOtherIncomeDoc = async (params) => {
  const { json /*, headers, status */ } = await httpClient(
    API_URL_DOC + `/income/getotherincome/${params.id}`
  );
  const r = json; // Original uses 'r'

  const newRes1 = {
    ...r,
    records: {
      ...r?.records,
      other_income_details: {
        ...r?.records?.other_income_details,
        otherincome: r?.records?.other_income_details?.otherincome?.map( // Added optional chaining
          (item) => {
            return {
              ...item,
              availableToUpload:
                item.files.length > 0
                  ? "Yes"
                  : item.no_doc_reason != null // Original had '!='
                    ? "No"
                    : "",
              fileCount: item.files.length,
            };
          }
        ),
      },
    },
  };
  return {
    data: {
      id: params.id,
      ...newRes1.records,
    },
  };
};

// 18. otherDoc
export const handleOtherDoc = async (params) => {
  const { json /*, headers, status */ } = await httpClient(
    API_URL_DOC + `/income/getothedocs/${params.id}` // Typo 'getothedocs' is from original
  );
  // const r = json;
  return {
    data: {
      id: params.id,
      ...json?.records, // Original used r?.records
    },
  };
};

// 19. getMetaData
export const handleGetMetaData = async (params) => {
  const { json /*, headers, status */ } = await httpClient(
    API_URL_DOC +
    `/income/docupload/getMetadata/${params.meta.trn_id}/${params.id}`
  );
  return {
    data: {
      id: params.id,
      ...json,
    },
  };
};

// 20. getapplicationgraph
export const handleGetApplicationGraph = async (params) => {
  let url = `/common/getapplicationgraph?subscriberid=${params.id
    }&app_invitation_type=${params?.meta?.app_invitation_type || 1}`;
  if (!params.id) {
    url = `/common/getapplicationgraph?app_invitation_type=${params?.meta?.app_invitation_type || 1
      }`;
  }
  const { json } = await httpClient(`${API_URL}${url}`, {
    method: "GET",
  });
  // const res = await json; // httpClient presumably already resolves json
  return {
    data: { id: 1, ...json.data }, // Original: ...res.data
  };
};

// 21. getapplicationcountstatus
export const handleGetApplicationCountStatus = async (params) => {
  const property = sanitizeQueryParams(params?.meta?.property) || "";
  const agent = sanitizeQueryParams(params?.meta?.agent) || "";
  const floor = sanitizeQueryParams(params?.meta?.floor) || "";
  const q = sanitizeQueryParams(params?.meta?.q) || "";
  const rangefrom = sanitizeQueryParams(params?.meta?.rangefrom) || "";
  const rangeto = sanitizeQueryParams(params?.meta?.rangeto) || "";
  const applicationstatus = sanitizeQueryParams(
    Array.isArray(params?.meta?.applicationstatus)
      ? params?.meta?.applicationstatus.toString()
      : params?.meta?.applicationstatus
  ) || "";
  const query = new URLSearchParams();
  if (params?.meta?.app_invitation_type) {
    query.set("app_invitation_type", String(params.meta.app_invitation_type));
  }
  if (params?.id) {
    query.set("subscriberid", String(params.id));
  }
  if (property) {
    query.set("property", property);
  }
  if (agent) {
    query.set("agent", agent);
  }
  if (applicationstatus) {
    query.set("applicationstatus", applicationstatus);
  }
  if (floor) {
    query.set("floor", floor);
  }
  if (q) {
    query.set("q", q);
  }
  if (rangefrom) {
    query.set("rangefrom", rangefrom);
  }
  if (rangeto) {
    query.set("rangeto", rangeto);
  }
  const { json } = await httpClient(
    `${API_URL}/common/getapplicationcountstatus?${query.toString()}`,
    { method: "GET" }
  );
  // const res = await json;
  return {
    data: { id: 1, records: json.data }, // Original: records: res.data
  };
};

// 22. docuploadmanagementstats
export const handleDocUploadManagementStats = async (params) => {
  const SubscriberData = localStorage.getItem("RaStore.switchSubscriberName");
  const { data: authData } = JSON.parse(localStorage.getItem("auth") || "{}") || {};
  const SubscriberDataJson = SubscriberData ? JSON.parse(SubscriberData) : null;
  const subscriberId = SubscriberDataJson?.value || authData?.subscriberid;

  const { json } = await httpClient(
    `${API_URL}/subscriber/getdocuploadreportcount?subscriberid=${subscriberId}`,
    {
      method: "GET",
    }
  );
  return { data: { id: params.id, records: json } }; // Original had params.id, which might not be defined if this route doesn't use it. Assuming id: 1 or a relevant id if available.
                                                    // Sticking to original: params.id could be undefined.
};

// 23. verificationmanagementstats
export const handleVerificationManagementStats = async (params) => {
  const formatDate = (date) => {
    if (!(date instanceof Date) || isNaN(date.getTime())) { // Original checked isNaN first, added instanceof check
        return " ";
    }
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };

  const rangetoDate = new Date(); // Renamed from rangeto to avoid conflict
  const currentDate = new Date();
  rangetoDate.setDate(currentDate.getDate() - 30);

  const rangefrom = params?.meta?.rangefrom && params?.filter?.rangefrom // filter was used in original for rangefrom/to
    ? formatDate(new Date(params.filter.rangefrom))
    : formatDate(rangetoDate);
  const rangetoFormatted = params?.meta?.rangeto && params?.filter?.rangeto
    ? formatDate(new Date(params.filter.rangeto))
    : formatDate(currentDate);

  const rangefromFinal = rangefrom || " ";
  const rangetoFinal = rangetoFormatted || " ";

  const { json } = await httpClient(
    `${API_URL}/admin/getverificationreportcount?q=${params?.meta?.q || ""}&rangefrom=${rangefromFinal || ""}&rangeto=${rangetoFinal || ""}&subscribername=${params?.meta?.subscribername || ""}`,
    {
      method: "GET",
    }
  );
  return { data: { id: params.id, records: json } }; // params.id might be undefined
};

// 24. getfilterforinbox
export const handleGetFilterForInbox = async (params) => {
  const { json /*, headers, status */ } = await httpClient(
    `${API_URL}/common/getfilterforinbox` +
    (params.id ? `?subscriberid=${params.id}` : ``),
    { method: "GET" }
  );
  return {
    data: { id: params.id, ...json.data }, // params.id might be undefined
  };
};

// 25. getnewapplicationdetail
export const handleGetNewApplicationDetail = async (params) => {
  const { json } = await httpClient(
    `${API_URL}/common/getnewapplicationdetail` +
    (params.id ? `?subscriberid=${params.id}` : ""),
    { method: "GET" }
  );
  // const res = await json;
  return {
    data: { id: params.id, ...json.data }, // params.id might be undefined; Original: res.data
  };
};

// 26. getipaddress (uses global fetch)
export const handleGetIpAddress = async (params) => {
  const result = await fetch(`https://geolocation-db.com/json/`, {
    method: "GET",
  });
  const resJson = await result.json(); // Renamed from res to avoid conflict
  return {
    data: { id: params.id, ...resJson }, // params.id might be undefined
  };
};

// 27. getapplicationinboxdetails
export const handleGetApplicationInboxDetails = async (params) => {
  const { json /*, headers, status */ } = await httpClient(
    `${API_URL}/common/getapplicationinboxdetails/${params?.id}`,
    { method: "GET" }
  );
  return {
    data: { id: params.id, ...json },
  };
};

// 28. getidentification
export const handleGetIdentification = async (params) => {
  const { json /*, headers, status */ } = await httpClient(
    `${API_URL}/applicant/applicant/getidentification/${params.id}`,
    { method: "GET" }
  );
  const response = json;
  if (response.records?.address?.length > 0) {
    // Original had 'await response.records?.address.map(async ...)'
    // .map with async callback returns an array of Promises.
    // If side effects are intended, Promise.all might be needed if results of map are used.
    // Here it seems to mutate singleAddress.state directly.
    await Promise.all(response.records.address.map(async (singleAddress) => { // Ensure completion
      response.records.states.filter((state) => { // filter doesn't need await
        if (state.ID == singleAddress.state) { // Original had '=='
          let body = {
            value: state.ID,
            label: state.StateName,
          };
          singleAddress.state = body;
        }
        return false; // filter needs a return
      });
    }));
  }

  const resData = { // Renamed from res
    ...response.records,
    applicant: {
      ...response.records?.applicant,
      otherPhoneCaption: {
        value: response.records?.applicant?.otherPhoneCaption,
        label: response.records?.applicant?.otherPhoneCaption,
      },
      alias_status:
        response.records?.applicant?.Alias?.length > 0 ? "Yes" : "No",
      no_doc_reason:
        response.records?.identification_data?.no_doc_reason ||
        "I don't currently have access to document(s), but can provide later",
      availableToUpload_id:
        response.records?.identification_data?.availableToUpload_id,
    },
    address: !response.records?.address?.length
      ? [
        {
          id: 0,
          is_current_address: true,
          move_in_date: null,
          move_out_date: null,
          current_rent: null,
          mortgage_rent: null,
        },
      ]
      : response.records.address,
  };
  return {
    data: { id: params.id, data: resData },
  };
};

// 29. ssnGetidentification
export const handleSsnGetIdentification = async (params) => {
  const { json /*, headers, status */ } = await httpClient(
    `${API_URL}/applicant/applicant/getidentification/${params.id}`,
    { method: "GET" }
  );
  const response = json;

  if (response.records?.address?.length > 0) {
     await Promise.all(response.records.address.map(async (singleAddress) => { // Ensure completion
      response.records.states.filter((state) => {
        if (state.ID == singleAddress.state) { // Original had '=='
          let body = {
            value: state.ID,
            label: state.StateName,
          };
          singleAddress.state = body;
        }
        return false;
      });
    }));
  }
  const resData = { // Renamed from res
    ...response.records,
    ssn_data: {
      ...response.records?.ssn_data,
      availableToUpload_ssn: response.records?.ssn_data?.file
        ? "Yes"
        : response.records?.ssn_data?.no_doc_reason
          ? "No"
          : response.records?.ssn_data?.other_reason
            ? "No"
            : "",
      no_doc_reason:
        response.records?.ssn_data?.no_doc_reason ||
        "I don't currently have access to document(s), but can provide later",
    },
  };
  return {
    data: { id: params.id, data: resData },
  };
};

// 30. getTandCpageforpayment
export const handleGetTandCPageForPayment = async (params) => {
  const { json /*, headers, status */ } = await httpClient(
    `${API_URL}/applicant/stripe/getTandCpageforpayment/${params.id}`,
    { method: "GET" }
  );
  // const response = json;
  return {
    data: { id: params.id, data: json }, // Original: data: response
  };
};

// 31. getpayment
export const handleGetPayment = async (params) => {
  const { json /*, headers, status */ } = await httpClient(
    `${API_URL}/applicant/stripe/getpayment/${params.id}`,
    { method: "GET" }
  );
  // const response = json;
  return {
    data: { id: params.id, data: json }, // Original: data: response
  };
};

// 32. contextualgetdetails
export const handleContextualGetDetails = async (params) => {
  const { json /*, headers, status */ } = await httpClient(
    `${API_URL}/applicant/contextual/getdetails/${params.id}`,
    { method: "GET" }
  );
  const response = json;
  let labelCount = 0;
  const getQuestionOrDefault = (index, displayDefault = false, requiredDefault = false, responseDefault = "no") => {
    const question = response?.records?.[index];
    if (question) {
      const display = question.display;
      if (display) {
        labelCount++;
      }
      return {
        ...question,
        labelCount: display ? labelCount : labelCount, // original was ++labelCount only if display is true
        labelIndex: labelCount, // This will be the same as labelCount if displayed, or the previous if not.
      };
    }
    return { display: displayDefault, required: requiredDefault, response: responseDefault, labelIndex: labelCount };
  };
  
  // Reset labelCount for consistent indexing per call
  labelCount = 0; 
  const anyone_over_18 = getQuestionOrDefault(0);
  const co_occupants = getQuestionOrDefault(1, false, false, "no"); // Original logic for co_occupants had length check response?.records[1]?.length > 0 which is not directly translatable to getQuestionOrDefault pattern easily. Assuming response.records[1] is the question object itself.
                                                                    // If response.records[1] is an array of co_occupants, this needs adjustment.
                                                                    // For now, using the pattern, assuming it's a question object like others.
  const is_co_signer = getQuestionOrDefault(2);
  const reference = getQuestionOrDefault(3);
  const emergency_reference = getQuestionOrDefault(4);
  const have_pet = getQuestionOrDefault(5); // Original indices were [0]..[4], then [8],[10],[11],[13],[7],[6],[5],[12],[9]
  const have_vehicle = getQuestionOrDefault(6);
  const is_student = getQuestionOrDefault(7);
  const renters_insurance = getQuestionOrDefault(8);
  const convicted_for_crime = getQuestionOrDefault(9);
  const eviction_or_nonpayment = getQuestionOrDefault(10);
  const contingencies = getQuestionOrDefault(11);
  const do_you_smoke = getQuestionOrDefault(12);
  const filed_for_bankruptcy = getQuestionOrDefault(13);


  const resData = { // Renamed from res
    questionsLength: response?.records?.length || 0,
    anyone_over_18,
    co_occupants, // Special handling might be needed if response.records[1] is an array
    is_co_signer,
    reference,
    emergency_reference,
    renters_insurance,
    eviction_or_nonpayment,
    contingencies,
    filed_for_bankruptcy,
    is_student,
    have_vehicle,
    have_pet,
    do_you_smoke,
    convicted_for_crime,
  };

  return {
    data: { id: params.id, ...resData },
  };
};

// 33. getsubscribercount
export const handleGetSubscriberCount = async (params) => {
  const { json /*, headers, status */ } = await httpClient(
    `${API_URL}/admin/getsubscribercount`,
    { method: "GET" }
  );
  // const response = json?.data;
  return {
    data: { id: params.id, records: json?.data }, // params.id might be undefined
  };
};

// 34. getqueuecount
export const handleGetQueueCount = async (params) => {
  const { json /*, headers, status */ } = await httpClient(
    `${API_URL}/admin/getqueuecount`,
    { method: "GET" }
  );
  // const response = json?.data;
  return {
    data: { id: params.id, records: json?.data }, // params.id might be undefined
  };
};

// 35. getactivedatagraph
export const handleGetActiveDataGraph = async (params) => {
  let url = `/account/getactivedatagraph?isday=${params.id}`;
  const { json } = await httpClient(`${API_URL}${url}`, {
    method: "GET",
  });
  // const res = await json;
  return {
    data: { id: 1, ...json.data }, // Original: res.data
  };
};

// 36. getgraphdata
export const handleGetGraphData = async (params) => {
  let url = `/account/getgraphdata`;
  const { json } = await httpClient(`${API_URL}${url}`, {
    method: "GET",
  });
  // const res = await json;
  const newResp = {
    ...json.data, // Original: res.data
    osdata: json?.data?.osdata?.map((item) => {
      item.name = item.OS;
      item.value = item.Users;
      delete item.OS;
      delete item.Users;
      return item;
    }),
    broswerdata: json?.data?.broswerdata?.map((item) => { // Corrected typo from broswerdata to browserdata if intended, original was broswerdata
      item.name = item.Browser;
      item.value = item.Users;
      delete item.Browser;
      delete item.Users;
      return item;
    }),
  };
  return {
    data: { id: 1, ...newResp },
  };
};

// 37. mlbanklist
export const handleMlBankList = async (params) => { // API_URL_DOC was used
  const { json } = await httpClient(`${API_URL_DOC}/ml/mlbanklist`, {
    method: "GET",
  });
  // const res = await json;
  return {
    data: { id: 1, data: json }, // Original: data: res
  };
};

// 38. getalldocs
export const handleGetAllDocs = async (params) => {
  const { json } = await httpClient(
    `${API_URL}/common/getalldocs/${params.id}`,
    { method: "GET" }
  );
  // const res = await json;
  return {
    data: { id: 1, data: json?.data }, // Original: res?.data
  };
};

// 39. getSecondaryApp
export const handleGetSecondaryApp = async (params) => {
  const { json } = await httpClient(
    `${API_URL}/applicant/contextual/getsecondaryapplicationdetails/${params.id}`,
    { method: "GET" }
  );
  // const res = await json;
  return {
    data: { id: 1, data: json?.records }, // Original: res?.records
  };
};

// 40. getdatapolicy
export const handleGetDataPolicy = async (params) => {
  const { json } = await httpClient(
    `${API_URL}/account/getdatapolicy/`,
    { method: "GET" }
  );
  // const res = await json;
  return {
    data: { id: 1, data: json?.records }, // Original: res?.records
  };
};

// 41. gettermsofuse
export const handleGetTermsOfUse = async (params) => {
  const { json } = await httpClient(
    `${API_URL}/account/gettermsofuse/`,
    { method: "GET" }
  );
  // const res = await json;
  return {
    data: { id: 1, data: json?.records }, // Original: res?.records
  };
};

// 42. registrationpage (uses global Headers)
export const handleRegistrationPage = async (params) => {
  const headers = new Headers();
  headers.append("url", params.id);
  const { json } = await httpClient(
    `${API_URL?.replace("/api", "")}/users/registrationpage`, // API_URL might be undefined, handle carefully
    { headers: headers, method: "GET" }
  );
  // const res = await json;
  return {
    data: { id: 1, data: json }, // Original: data: res
  };
};

// 43. viewappreport
export const handleViewAppReport = async (params) => {
  // Without a local bound, a hung request pins the View App spinner until
  // the browser's own network timeout (minutes).
  const VIEW_APP_REPORT_TIMEOUT_MS = 40000;
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), VIEW_APP_REPORT_TIMEOUT_MS);
  try {
    const { json } = await httpClient(
      `${API_URL}/common/view-app-report`,
      { method: "POST", body: JSON.stringify(params?.id), signal: controller.signal } // Original params?.id
    );
    return {
      data: { id: 1, ...json }, // Original: ...res
    };
  } catch (error: any) {
    // httpClient re-throws a spread copy of the error, which drops the
    // DOMException name — detect the abort from the controller instead.
    if (controller.signal.aborted) {
      throw new Error("View report request timed out");
    }
    throw error;
  } finally {
    clearTimeout(timeoutId);
  }
};

// 44. getApplicants
export const handleGetApplicants = async (params) => {
  const { json } = await httpClient(
    `${API_URL}/subscriber/get-applicants?ApplicationNumber=${params?.id}`,
    { method: "GET" }
  );
  // const res = await json;
  return {
    data: { id: 1, ...json }, // Original: ...res
  };
};

// 45. getStates
export const handleGetStates = async (params) => {
  const { json } = await httpClient(`${API_URL}/common/getStates`, {
    method: "GET",
  });
  // const res = await json;
  return {
    data: { id: 1, ...json }, // Original: ...res
  };
};

// 46. application-profile
export const handleApplicationProfile = async (params) => {
  const { json } = await httpClient(
    `${API_URL}/subscriber/application-profile/${params?.id}`,
    { method: "GET" }
  );
  // const res = await json;
  return {
    data: { id: 1, ...json }, // Original: ...res
  };
};

// 47. lease-template
export const handleLeaseTemplate = async (params) => {
  const { json } = await httpClient(
    `${API_URL}/subscriber/lease-template/${params?.id}`,
    { method: "GET" }
  );
  // const res = await json;
  return {
    data: { id: 1, ...json }, // Original: ...res
  };
};

// 48. get-third-party-apps
export const handleGetThirdPartyApps = async (params) => {
  const { json } = await httpClient(
    `${API_URL}/subscriber/get-third-party-apps/${params?.id}`,
    { method: "GET" }
  );
  // const res = await json;
  return {
    data: { id: 1, ...json }, // Original: ...res
  };
};

// 49. subscriber-screening-company
export const handleSubscriberScreeningCompany = async (params) => {
  const { json } = await httpClient(
    `${API_URL}/subscriber/subscriber-screening-company/${params?.id}`,
    { method: "GET" }
  );
  // const res = await json;
  return {
    data: { id: 1, ...json }, // Original: ...res
  };
};

// 50. adverse-letter
export const handleAdverseLetter = async (params) => {
  const { json } = await httpClient(
    `${API_URL}/subscriber/adverse-letter/${params?.id}`,
    { method: "GET" }
  );
  // const res = await json;
  return {
    data: { id: 1, ...json }, // Original: ...res
  };
};

// 51. get-property-details
export const handleGetPropertyDetails = async (params) => {
  const { json } = await httpClient(
    `${API_URL}/subscriber/${params?.id?.type === "Office"
      ? `get-office`
      : `get-property-details`
    }?${params?.id?.type === "Office" ? `officeID` : `propertyID`}=${params?.id?.propertyID
    }&subscriberID=${params?.id?.subscriberID}`,
    { method: "GET" }
  );
  // const res = await json;
  return {
    data: { id: 1, ...json }, // Original: ...res
  };
};

// 52. integration-setting-rule (logic is identical to get-property-details in original)
export const handleIntegrationSettingRule = async (params) => {
  const { json } = await httpClient(
    `${API_URL}/subscriber/${params?.id?.type === "Office" // This logic was duplicated in original for this resource
      ? `get-office`
      : `get-property-details`
    }?${params?.id?.type === "Office" ? `officeID` : `propertyID`}=${params?.id?.propertyID
    }&subscriberID=${params?.id?.subscriberID}`,
    { method: "GET" }
  );
  // const res = await json;
  return {
    data: { id: 1, ...json }, // Original: ...res
  };
};

// 53. list-third-party-apps
export const handleListThirdPartyApps = async (params) => {
  const { json } = await httpClient(
    `${API_URL}/subscriber/list-third-party-apps`,
    { method: "GET" }
  );
  // const res = await json;
  return {
    data: { id: 1, ...json }, // Original: ...res
  };
};

// 54. screening-company
export const handleScreeningCompany = async (params) => {
  const { json } = await httpClient(
    `${API_URL}/subscriber/screening-company`,
    { method: "GET" }
  );
  // const res = await json;
  return {
    data: { id: 1, ...json }, // Original: ...res
  };
};

// 55. company-type
export const handleCompanyType = async (params) => {
  const { json } = await httpClient(
    `${API_URL}/subscriber/company-type`,
    { method: "GET" }
  );
  // const res = await json;
  return {
    data: { id: 1, ...json }, // Original: ...res
  };
};

// 56. get-subscriber
export const handleGetSubscriber = async (params) => {
  const { json } = await httpClient(
    `${API_URL}/subscriber/get-subscriber/${params?.id}`,
    { method: "GET" }
  );
  // const res = await json;
  return {
    data: { id: 1, data: json?.records }, // Original: id:1, data: res?.records. params.id was not used for the returned 'id' field.
  };
};

// 57. subscriber-third-party-menu
export const handleSubscriberThirdPartyMenu = async (params) => {
  const { json } = await httpClient(
    `${API_URL}/subscriber/subscriber-third-party-menu?subscriberID=${params?.id}`,
    { method: "GET" }
  );
  // const res = await json;
  return {
    data: { id: 1, ...json }, // Original: ...res
  };
};

// 58. get-stripe-details
export const handleGetStripeDetails = async (params) => {
  const { json } = await httpClient(
    `${API_URL}/subscriber/getStripe/${params?.id?.type === "Office" ? "office" : "property"
    }?ID=${params?.id?.id}`,
    { method: "GET" }
  );
  // const res = await json;
  return {
    data: { id: 1, ...json }, // Original: ...res
  };
};

// 59. getDownloadDocumentsMessage
export const handleGetDownloadDocumentsMessage = async (params) => {
  const { json } = await httpClient(
    `${API_URL}/applicant/applicant/getdownloaddocuments/${params?.id}`,
    { method: "GET" }
  );
  // const res = await json;
  return {
    data: { id: 1, ...json }, // Original: ...res
  };
};

// 60. getlookbacks
export const handleGetLookbacks = async (params) => {
  const { json } = await httpClient(
    `${API_URL}/subscriber/getlookbacks?applicationnumber=${params?.id}`,
    { method: "GET" }
  );
  // const res = await json;
  return {
    data: { id: 1, ...json }, // Original: ...res
  };
};

// 61. get-subscriber-configurations
export const handleGetSubscriberConfigurations = async (params) => {
  const { json } = await httpClient(
    `${API_URL}/subscriber/subscriber-configurations/${params?.id}`,
    { method: "GET" }
  );
  // const res = await json;
  return {
    data: { id: 1, ...json }, // Original: ...res
  };
};

export const handleGetBankIncomeValidationCheck = async (params) => {
  const { json } = await httpClient(
    `${API_URL}/plaid/bankIncomeValidationCheck/${params.id}`,
    { method: "GET" }
  );
  return {
    data: { ...json },
  };
}

export const handleGetPayrollIncomeValidationCheck = async (params) => {
  const { json } = await httpClient(
    `${API_URL}/plaid/payrollIncomeValidationCheck/${params.id}`,
    { method: "GET" }
  );
  return {
    data: { ...json },
  };
}

export const handleGetPlaidBankIncomeEnabled = async (params) => {
  const { json } = await httpClient(
    `${API_URL}/plaid/plaidBankIncomeEnabled/${params.id}`,
    { method: "GET" }
  );
  return {
    data: { id: 1, ...json },
  };
};

export const handleGetPlaidPayrollIncomeEnabled = async (params) => {
  const { json } = await httpClient(
    `${API_URL}/plaid/plaidPayrollIncomeEnabled/${params.id}`,
    { method: "GET" }
  );
  return {
    data: { id: 1, ...json },
  };
};

export const handleGetArgyleBankIncomeEnabled = async (params) => {
  const { json } = await httpClient(
    `${API_URL}/argyle/argyleBankIncomeEnabled/${params.id}`,
    { method: "GET" }
  );
  return {
    data: { id: 1, ...json },
  };
};

export const handleGetArgylePayrollIncomeEnabled = async (params) => {
  const { json } = await httpClient(
    `${API_URL}/argyle/argylePayrollIncomeEnabled/${params.id}`,
    { method: "GET" }
  );
  return {
    data: { id: 1, ...json },
  };
};

export const handleGetArgylePayrollIncomeValidationCheck = async (params) => {
  const { json } = await httpClient(
    `${API_URL}/argyle/payrollIncomeValidationCheck/${params.id}`,
    { method: "GET" }
  );
  return {
    data: { id: 1, ...json },
  };
};

export const handleGetArgyleBankIncomeValidationCheck = async (params) => {
  const { json } = await httpClient(
    `${API_URL}/argyle/bankIncomeValidationCheck/${params.id}`,
    { method: "GET" }
  );
  return {
    data: { ...json, id: params.id || json?.id || 1 },
  };
};
// Resolves which provider is active for a given (trn_id, feature) scope.
// Feature is passed as a query param alongside trn_id (used as params.id for
// handler symmetry; callers should also pass params.meta?.feature or encode
// the feature in the id string).
export const handleGetIncomeVerificationProvider = async (params) => {
  const feature = params?.meta?.feature || params?.feature || 'payroll_income';
  const trnId = params?.id;
  const { json } = await httpClient(
    `${API_URL}/income-verification/provider?feature=${encodeURIComponent(feature)}&trn_id=${encodeURIComponent(trnId)}`,
    { method: "GET" }
  );
  return {
    data: { ...json, id: params?.id || json?.id || 1 },
  };
};

export const handleGetRiskIndicatorIsFraudRisk = async (params) => {
  const { json } = await httpClient(
    `${API_URL}/applicant/riskIndicator/isFraudRisk`,
    {
      method: "POST",
      body: JSON.stringify({
        applicant: params?.meta?.applicant || {},
        context: params?.meta?.context || {},
      }),
    }
  );

  return {
    data: {
      id: params?.id || 1,
      riskFlag: Boolean(
        json?.riskFlag ?? json?.data?.riskFlag ?? json?.records?.riskFlag
      ),
    },
  };
};
